import React, { useState, useEffect, useRef } from "react";
import * as styles from "./SecondVideoCafetera.module.scss";
import { motion } from "framer-motion";

const SecondVideoCafetera = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isLoading, setIsLoading] = useState(true); // Estado para el indicador de carga
  const containerRef = useRef(null);

  // Función ajustada para generar el nombre del archivo de imagen
  const getImageFileName = (index) => {
    // Ajustando el índice para que empiece en 36000
    const adjustedIndex = 36000 + index;
    return `cafe_${adjustedIndex}.png`;
  };

  useEffect(() => {
    const imageUrls = [];
    // Ajustando el bucle para que itere sobre el rango correcto de imágenes
    for (let i = 0; i <= 90; i++) {
      // Asumiendo que tienes 91 imágenes en total
      const imageUrl =
        require(`../../../images/video/cafetera-secuencia/${getImageFileName(
          i
        )}`).default;
      imageUrls.push(imageUrl);
    }

    const imagePromises = imageUrls.map((url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = url;
      });
    });

    Promise.all(imagePromises)
      .then(() => setIsLoading(false))
      .catch((error) => console.error("Error loading images:", error));

    const handleScroll = () => {
      if (containerRef.current) {
        const sectionTop = containerRef.current.offsetTop;
        const sectionHeight = containerRef.current.offsetHeight;
        const scrollPosition = window.scrollY;

        if (
          scrollPosition >= sectionTop &&
          scrollPosition <= sectionTop + sectionHeight
        ) {
          const scrollWithinSection = scrollPosition - sectionTop;
          const scrollFraction = scrollWithinSection / sectionHeight;
          // Ajuste en el cálculo del índice de la imagen basado en el nuevo rango
          const imageIndex = Math.min(Math.floor(scrollFraction * 91), 90); // 91 representa el total de imágenes
          setCurrentImage(imageIndex);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <h1>Cargando...</h1>
      </div>
    );
  }

  return (
    <motion.section
      ref={containerRef}
      className={styles.container_section}
      style={{
        height: "800vh",
        position: "relative",
        display: "flex",
        zIndex: "-300",
        scrollSnapAlign: "center",
        backgroundColor: "black",
      }}
    >
      <img
        key={currentImage}
        src={
          require(`../../../images/video/cafetera-secuencia/${getImageFileName(
            currentImage
          )}`).default
        }
        alt=""
        style={{
          maxWidth: "100%",
          maxHeight: "700px",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
    </motion.section>
  );
};

export default SecondVideoCafetera;
